import React, { useState } from "react";
import { useSearchParams, useNavigate } from "react-router-dom";
import "./IDLogin.css";
import { getEmployeeInfoByIdentityCardId } from "../../services/EmployeeService";

const IDLogin = () => {
  const [isFocused, setIsFocused] = useState(false);
  const [value, setValue] = useState("");
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();

  const isIdValid = value.length === 9;
  const pass_id = searchParams.get("code"); // Get the pass_id from URL query parameter

  const handleLogin = async () => {
    if (isIdValid) {
      setLoading(true);
      setError(null);

      try {
        const employeeInfo = await getEmployeeInfoByIdentityCardId(value);

        // Check if the response has record property and if it's null
        if (
          employeeInfo &&
          "record" in employeeInfo &&
          (employeeInfo as any).record === null
        ) {
          setError("no employee found with this id number");
        } else if (employeeInfo && (employeeInfo as any).record) {
          const record = (employeeInfo as any).record;
          navigate("/pass/info", {
            state: {
              compagnyName: record.compagny?.name || undefined,
              passId: pass_id || undefined,
              compagnyId: record.compagny_id,
              imageUrl: record.compagny?.image_url,
              employeeName: record.first_name,
              employeeId: record.id,
            },
          });
        } else {
          setError("No employee found with this id number");
        }
      } catch (err: any) {
        console.error("Error fetching employee data:", err);
        setError(
          err.response?.data?.message ||
            err.message ||
            "Failed to login. Please try again."
        );
      } finally {
        setLoading(false);
      }
    }
  };

  return (
    <div className="id-login-container">
      <img
        src="/Frame 29611912.svg"
        alt="ID Login"
        className="id-login-image"
      />
      <img
        src="/Premium Club.svg"
        alt="Premium Club"
        className="premium-club-image"
      />
      <span className="exclusive-club-text">Exclusive Club</span>
      <span className="insert-id-text">Insert your ID number</span>
      <div className="id-input-container">
        <div className="input-wrapper">
          <label
            className={`floating-label ${
              isFocused || value ? "floating-label-up" : ""
            }`}
          >
            ID number
          </label>
          <input
            type="text"
            className="id-input-field"
            value={value}
            onChange={(e) => {
              const inputValue = e.target.value;
              // Only allow numbers
              if (inputValue === "" || /^\d+$/.test(inputValue)) {
                setValue(inputValue);
              }
            }}
            onFocus={() => setIsFocused(true)}
            onBlur={() => setIsFocused(false)}
          />
        </div>
      </div>
      <button
        className="login-button"
        onClick={handleLogin}
        disabled={!isIdValid || loading}
      >
        {loading ? "Loading..." : "Login"}
      </button>
      {error && (
        <div style={{ color: "red", marginTop: "10px", textAlign: "center" }}>
          {error}
        </div>
      )}
    </div>
  );
};

export default IDLogin;
